const DISMISS_STORAGE_KEY = 'two-fa-banner-dismissed-at';
const DISMISS_DURATION_MS = 7 * 24 * 60 * 60 * 1000;

export const isDismissed = (): boolean => {
    try {
        const dismissedAt = localStorage.getItem(DISMISS_STORAGE_KEY);
        if (!dismissedAt) return false;
        return Date.now() - Number(dismissedAt) < DISMISS_DURATION_MS;
    } catch {
        return false;
    }
};

export const dismiss = (): void => {
    try {
        localStorage.setItem(DISMISS_STORAGE_KEY, String(Date.now()));
    } catch {
        /* localStorage may be unavailable */
    }
};
